module.exports = __webpack_public_path__ + "static/media/Aileron-Regular-01.639cb652.svg";